import axios from "../axios-api";

export const getChannel = ({ token, channelId, language = "fr", userId }) => {
  const requestUrl = `/event/channel`;

  const fields = [
    "*",
    "cover",
    "rubricCounter",
    "articleCounter",
    "eventCounter",
    "mediaChain",
    "author",
    "chains",
    "tag",
    "eventPlace",
    "isChannelPartner",
    "articlesCounter",
    "articles",
    "cycles",
    "events",
    "eventIds",
    "authors",
    "chainAuthors",
  ];

  const filter = [
    {
      property: "id",
      operator: "eq",
      value: channelId,
    },
  ];

  const params = {
    access_token: token,
    filter: JSON.stringify(filter),
    fields: fields.join(","),
    limit: 1,
    start: 0,
    language,
  };

  if (userId) {
    params.userId = userId;
  }

  return axios.get(requestUrl, { params });
};
